import { render } from "./VideoForm.vue?vue&type=template&id=16474551"
import script from "./VideoForm.vue?vue&type=script&lang=js"
export * from "./VideoForm.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./VideoForm.vue?vue&type=style&index=0&id=16474551&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__